import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMapPin, FiMail, FiFacebook, FiInstagram, FiTwitter } = FiIcons;

function Footer() {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' }
  ];

  const services = [
    'Hair Cut',
    'Beard Trim',
    'Hot Towel Shave',
    'Hair Styling',
    'Mustache Grooming'
  ];

  return (
    <footer className="bg-black border-t border-yellow-500/20 mt-auto relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center">
                <span className="text-black font-bold text-xl">W</span>
              </div>
              <span className="ml-3 text-xl font-bold text-yellow-400">West End Barbers</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium barbershop in Toronto offering expert haircuts, beard trims, and grooming services with traditional craftsmanship and modern style.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <SafeIcon icon={FiFacebook} className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <SafeIcon icon={FiInstagram} className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                <SafeIcon icon={FiTwitter} className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-yellow-400 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold text-yellow-400 mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-gray-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-yellow-400 mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <SafeIcon icon={FiMapPin} className="h-4 w-4 text-yellow-400 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  2925 Dundas St W, Toronto, ON M6P 1Z1, Canada
                </span>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiPhone} className="h-4 w-4 text-yellow-400 mr-3 flex-shrink-0" />
                <a
                  href="tel:+14166379929"
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  +1 (416) 637-9929
                </a>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiMail} className="h-4 w-4 text-yellow-400 mr-3 flex-shrink-0" />
                <a
                  href="mailto:info@westendbarbers.com"
                  className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm"
                >
                  info@westendbarbers.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-yellow-500/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 West End Barbers. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;